export default {
    electric_panels : {
        label: "ELECTRICAL PANEL",
        products: [
            {
                name:"Motor Starter Panel",
                product_id:"motor_starter_panel"
            },
            {
                name:"Power Factor Panel",
                product_id:"power_factor_panel"
            },
            {
                name:"AMF Panel",
                product_id:"AMF_panel"
            },
            {
                name:"Distribution Panel",
                product_id:"distribution_panel"
            }
        ]
    },
    industrial_inverters : {
        label:"INDUSTRIAL INVERTER",
        products: [
            {
                name:"Luminous",
                product_id:"luminous_ii"
            },
            {
                name:"Microtek",
                product_id:"microtek_ii"
            }
    ]},
    line_interactive_UPS : {
        label:"LINE INTERACTIVE UPS",
        products: [
            {
                name:"Luminous",
                product_id:"luminous"
            },
            {
                name:"Intex",
                product_id:"intex"
            },
            {
                name:"Microtek",
                product_id:"microtek"
            }
        ]
    },
    online_UPS : {
        label:"ONLINE UPS",
        products: [
            {
                name:"Vertiv",
                product_id:"vertiv"
            },
            {
                name:"Nexus",
                product_id:"nexus"
            },
            {
                name:"APC",
                product_id:"APC"
            },
            {
                name:"Numeric",
                product_id:"numeric"
            },
            {
                name:"Eaton",
                product_id:"eaton"
            },

        ]
    },
    power_generator : {
        label:"POWER GENERATOR",
        products: [
            {
                name:"CSH by Ashok Leyland",
                product_id:"CSH_by_ashok_leyland"
            }
        ]
    },
    servo_voltage_stabilizer : {
        label:"SERVO VOLTAGE STABILIZER",
        products: [
            {
                name:"Sparrow",
                product_id:"sparrow"
            }
        ]
    },
    smf_battery : {
        label:"SMF BATTERY",
        products: [
            {
                name:"Exide",
                product_id:"exide"
            },
            {
                name:"Amaron",
                product_id:"amaron"
            }
        ]
    },
    solar_system : {
        label:"SOLAR SYSTEM",
        products: [
            {
                name:"Solar Battery",
                product_id:"solar_battery"
            },
            {
                name:"Solar Inverter",
                product_id:"solar_inverter"
            },
            {
                name:"Solar Panel",
                product_id:"solar_panel"
            }
        ]
    }
}